import { linkToTeacherDashboard } from "../../links";

export function linkToSchoolPage() {
  return `${linkToTeacherDashboard()}/school`;
}
